module.exports = __webpack_public_path__ + "static/media/wordsapp.30c9fa90.webp";